import styled from 'styled-components';

export const Container = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '20rem',

  height: '100%',

  overflow: 'auto',
}));

export const PricingContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  height: '100%',
  minInlineSize: '100rem',
  borderInlineStart: `1rem solid ${theme.header.primaryAccent.text}`,
  paddingInlineStart: '20rem',
  marginInlineStart: 'auto',
}));
